// Generated using typescript-generator version null on 2017-12-21 10:21:27.

import {Observable} from "rxjs/Rx";
import {Injectable} from "@angular/core";

export class TagLightDto implements Dto {
  libelle: string;
  code: string;
}

export class AbstractLongIdObject implements LongIdObject {
    id: number;
}

export class PaiementDto extends AbstractLongIdObject implements Dto {
    code: string;
    label: string;
    numero: string;
    montant: string;
  type: string;
  etat: string;
}

export class PresenceDto {
  present: boolean;
  anapath: boolean;
}

export class Response implements AutoCloseable {
    mediaType: MediaType;
  entity: any;
    lastModified: Date;
    date: Date;
    headers: any;
  metadata: any;
    allowedMethods: string[];
    cookies: { [index: string]: NewCookie };
  entityTag: EntityTag;
  links: Link[];
  stringHeaders: any;
  status: number;
  statusInfo: StatusType;
    length: number;
    language: Locale;
  location: URI;
}

export class CorrespondantDetailsDto {
    code: string;
    nom: string;
    adressePrincipale: AdresseDto;
    adresseLivraison: AdresseDto;
    telephone: string;
    fax: string;
    email: string;
    numFiness: string;
    numAdeli: string;
    codeRpps: string;
    typeCarte: string;
    correspondantParent: string;
}

export class UserInformations {
  id?: string;
  login?: string;
  prenom?: string;
  nom?: string;
  telephone?: string;
  role?: UserRole;
  metadata?: { [index: string]: any };
  lang?: Locale;
  modules?: string[];
  correspondants?: Correspondant[];
  date?: any;
  expires?: any;
  origine?: string;
  url?: string;
  codeRpps?: string;
  properties?: { [index: string]: any };
  'e-mail'?: string;
  daysBeforeExpire: number | undefined | null;
  firstConnection: boolean | undefined | null;
}

export class Profil {
  id?: number;
  libelle?: string;
  champs?: string;
}

export interface Dto {
}

export class MediaType {
    type: string;
    subtype: string;
    parameters: { [index: string]: string };
    wildcardType: boolean;
    wildcardSubtype: boolean;
}

export class Cookie {
    name: string;
    value: string;
    version: number;
    path: string;
    domain: string;
}

export class NewCookie extends Cookie {
    comment: string;
    maxAge: number;
    expiry: Date;
    secure: boolean;
    httpOnly: boolean;
}

export class EntityTag {
  value: string;
  weak: boolean;
}

export class Link {
  rel: string;
  uri: URI;
  uriBuilder: UriBuilder;
  rels: string[];
  params: { [index: string]: string };
  title: string;
  type: string;
}

export interface StatusType {
  family: Family;
  statusCode: number;
  reasonPhrase: string;
}

export class Locale implements Cloneable, Serializable {
}

export class URI implements Comparable<URI>, Serializable {
}

export interface AutoCloseable {
}

export class AdresseDto {
    ligne1: string;
    ligne2: string;
    ligne3: string;
    codePostal: string;
    ville: string;
    pays: string;
}

export class CorrespondantDto implements Dto {
    code: string;
    nom: string;
    tags: string[];
}

export class Correspondant {
    code: string;
    nom: string;
    tags: string[];
    dateDesactivation: any;
  metadata: { [index: string]: any };
}

export interface LongIdObject {
    id: number;
}

export class UriBuilder {
}

export interface Cloneable {
}

export interface Serializable {
}

export interface Comparable<T> {
}

export abstract class HttpClient {

    abstract request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

@Injectable()
export class IAuditWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * /info
     * Response code 200 - Le log a Ã©tÃ© ajoutÃ© avec succÃ¨s
     * Response code 500 - Erreur interne lors du log d'audit
     * HTTP POST /audit/info
     * Java method: fr.cerba.digicerba.authentification.webservices.audit.IAuditWebService.info
     */
    info(queryParams?: { url?: string; message?: string; }): RestResponse<void> {
      return this.httpClient.request({method: 'POST', url: uriEncoding`audit/info`, queryParams: queryParams});
    }
}

@Injectable()
export class IPaiementWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

  /**
   * /cancelTransaction
   * Response code 200 - Annulation de la transaction rÃ©alisÃ©ee avec succÃ¨s
   * Response code 500 - Erreur interne lors de l'annulation du paiement
   * HTTP GET /paiement/cancelTransaction
   * Java method: fr.cerba.digicerba.paiementfactures.webservices.paiement.IPaiementWebService.cancelTransaction
   */
  cancelTransaction(queryParams?: { Data?: string; Seal?: string; InterfaceVersion?: string; Encode?: string; locale?: string; }): RestResponse<void> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`paiement/cancelTransaction`,
      data: queryParams
    });
  }

    /**
     * findPaiementClient
     * Response code 200 - Import terminÃ©
     * HTTP POST /paiement/{numLabo}
     * Java method: fr.cerba.digicerba.paiementfactures.webservices.paiement.IPaiementWebService.findPaiementClient
     */
    findPaiementClient(numLabo: string, arg1: string[]): RestResponse<PaiementDto[]> {
      return this.httpClient.request({method: 'POST', url: uriEncoding`paiement/${numLabo}`, data: arg1});
    }

  /**
   * findPaiementPatient
   * Response code 200 - Import terminÃ©
   * HTTP GET /paiement/{numPatient}+{numDossier}
   * Java method: fr.cerba.digicerba.paiementfactures.webservices.paiement.IPaiementWebService.findPaiementPatient
   */
  findPaiementPatient(numPatient: string, numDossier: string): RestResponse<PaiementDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`paiement/${numPatient}+${numDossier}`});
  }

  /**
   * findPaiementEncours
   * Response code 200 - Import terminÃ©
   * HTTP GET /paiement/@{paiementKey}
   * Java method: fr.cerba.digicerba.paiementfactures.webservices.paiement.IPaiementWebService.findPaiementEncours
   */
  findPaiementEncours(paiementKey: string): RestResponse<PaiementDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`paiement/@${paiementKey}`});
  }

  /**
     * import
     * Response code 200 - Import terminÃ©
     * HTTP GET /paiement/import
     * Java method: fr.cerba.digicerba.paiementfactures.webservices.paiement.IPaiementWebService.importPaiement
     */
    importPaiement(): RestResponse<void> {
      return this.httpClient.request({method: 'GET', url: uriEncoding`paiement/import`});
    }

  /**
   * isPresent
   * Response code 200 -
   * HTTP GET /paiement/{numPatient}/isPresent
   * Java method: fr.cerba.digicerba.paiementfactures.webservices.paiement.IPaiementWebService.isPresent
   */
  isPresent(numPatient: string): RestResponse<PresenceDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`paiement/${numPatient}/isPresent`});
  }

  /**
   * /startTransaction
   * Response code 200 - Transaction dÃ©marrÃ©e avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la crÃ©ation de la transaction de paiement
   * HTTP POST /paiement/startTransaction
   * Java method: fr.cerba.digicerba.paiementfactures.webservices.paiement.IPaiementWebService.startTransaction
   */
  startTransaction(arg0: number[]): RestResponse<Response> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`paiement/startTransaction`, data: arg0});
  }
}

@Injectable()
export class IRessourceMultimediaWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * /{id}
     * Response code 200 - Ressource multimedia rÃ©cupÃ©rÃ©e avec succÃ¨s
     * Response code 422 - Id null ou inconnu
     * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration du contenu
     * HTTP GET /ressourcemultimedia/{id}
     * Java method: fr.cerba.digicerba.resourcemultimedia.webservices.IRessourceMultimediaWebService.getRessourceMultimedia
     */
    getRessourceMultimedia(id: number): RestResponse<Response> {
      return this.httpClient.request({method: 'GET', url: uriEncoding`ressourcemultimedia/${id}`});
    }
}

@Injectable()
export class ICorrespondantWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * /tags
     * Response code 200 - Retourne les tags du correspondant courant
     * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
     * HTTP GET /correspondant/tags/all
     * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getAllTags
     */
    getAllTags(): RestResponse<string[]> {
      return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags/all`});
    }

  /**
     * /
   * Response code 200 - Retourne le dÃ©tail des infos d'un correspondant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
     * HTTP GET /correspondant/{code}/details
     * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondantDetails
     */
    getCorrespondantDetails(code: string): RestResponse<CorrespondantDetailsDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/${code}/details`});
    }

    /**
     * /
     * Response code 200 - Retourne la liste des correspondant de l'utilisateur courant avec succÃ¨s
     * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
     * HTTP GET /correspondant/all
     * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondants
     */
    getCorrespondants(): RestResponse<CorrespondantDto[]> {
      return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/all`});
    }

    /**
     * /tags
     * Response code 200 - Retourne les tags du correspondant courant
     * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
     * HTTP GET /correspondant/tags
     * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getTags
     */
    getTags(): RestResponse<string[]> {
      return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags`});
    }
}

@Injectable()
export class INotificationsCommonWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * messages/count
   * HTTP GET /notification/messages/count
   * Java method: fr.cerba.digicerba.shared.webservices.user.INotificationsCommonWebService.countMessageNotifications
   */
  countMessageNotifications(): RestResponse<number> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/messages/count`});
  }
}

@Injectable()
export class ITechnicWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /correspondant/all
   * Response code 200 - Retourne les correspondants actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/correspondants/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/correspondants/all`});
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTags
   */
  getTags(queryParams?: { locale?: string; }): RestResponse<TagLightDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/tags/all`, queryParams: queryParams});
  }
}

@Injectable()
export class IUserInformationsWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * /check
     * Response code 200 - Retourne true si le module est accessible
     * Response code 401 - Le module n'est pas accessible
     * HTTP GET /check
     * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.checkAccess
     */
    checkAccess(): RestResponse<boolean> {
      return this.httpClient.request({method: 'GET', url: uriEncoding`check`});
    }

  /**
     * /
   * Response code 200 - Retourne les informations de l'utilisateur avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
     * HTTP GET /me
     * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.me
     */
    me(): RestResponse<UserInformations> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`me`});
    }
}

export type RestResponse<R> = Observable<R>;

export type UserRole =
  'COMPTE_LIE'
  | 'INVITE'
  | 'ANCIEN_COMPTE'
  | 'ADMINISTRATEUR'
  | 'RESPONSABLE'
  | 'MODULE'
  | 'PROSPECT';

export type Family = 'INFORMATIONAL' | 'SUCCESSFUL' | 'REDIRECTION' | 'CLIENT_ERROR' | 'SERVER_ERROR' | 'OTHER';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = '/paiement-factures/api/';
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/common/resources/resources.ts